/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useContext } from "react";
import PropTypes from 'prop-types';
import BodyClassName from "react-body-classname";
import { useStaticQuery, graphql } from "gatsby";
import { StoreContext } from "../context/StoreContext";
import Header from './header';
import Footer from './footer';
import './layout.css';

const Layout = ({ children, baseRoute, homeBottomBlurb }) => {
  const { isCartOpen, toggleCartOpen } = useContext(StoreContext);
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
      categories: allWpCategory(
        filter: { count: { gt: 0 }, parentId: { eq: null } }
      ) {
        edges {
          node {
            name
            uri
            id
            parentId
            wpChildren {
              nodes {
                name
                uri
                id
              }
            }
          }
        }
      }
    }
  `);

  if(data) {
    return (
      <BodyClassName className={isCartOpen ? "noscroll" : ""}>
        <>
          {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}

          <div className="dimmer" onClick={() => toggleCartOpen()}></div>
          <Header
            siteTitle={data.site.siteMetadata?.title || `Title`}
            siteDescription={
              data.site.siteMetadata?.description || `Description`
            }
            categories={data.categories.edges}
          />
          <div className={baseRoute}>
            <main>{children}</main>
            <Footer baseRoute={baseRoute} homeBottomBlurb={homeBottomBlurb} />
          </div>
        </>
      </BodyClassName>
    );
  } else {
    return null;
  }

};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  baseRoute: PropTypes.string,
  homeBottomBlurb: PropTypes.string,
};

export default Layout;
